import Images from "../../../media/images";

const HeaderText = () => {
  return (
    <>
      <div className="mt-3 px-4 ">
        <img src={Images.heading} alt="" />
      </div>
    </>
  );
};
export default HeaderText;
